/** @jsxImportSource @emotion/react */
import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';

const StyledSideToSideTableCell = styled(TableCell)(() => ({
  // width: '45%',
  padding: '5px',
  fontWeight: 'bold',
  fontSize: '0.5rem',
  marginRight: '10px',
  height: '25px',
}))

export default StyledSideToSideTableCell;